import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/configureStore"; // Typed dispatch
import userLoginAPIInstance from "../../services/userLoginAPI";
import { loadLoggedInUser } from "../../actions/loginActions";
import LoginResponse from "../../types/LoginResponse";

interface LoginModalProps {
  show: boolean;
  onClose: () => void;
  onLoginSuccess: (userLogin: LoginResponse) => void;
}

const LoginModal: React.FC<LoginModalProps> = ({
  show,
  onClose,
  onLoginSuccess,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch<AppDispatch>(); // Use AppDispatch here

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("userRoles");

    try {
      const responseData: LoginResponse | undefined =
        await userLoginAPIInstance.login({ email, password });

      if (responseData) {
        // Save tokens in local storage
        localStorage.setItem("authToken", responseData.token);
        localStorage.setItem("currentUser", JSON.stringify(responseData.user));
        localStorage.setItem("userRoles", JSON.stringify(responseData.roles));

        // Dispatch Redux action
        await dispatch(loadLoggedInUser(responseData.user)); // Dispatch thunk action

        // Success callback
        onLoginSuccess(responseData);

        // Close modal
        onClose();
      } else {
        throw new Error("Login failed. No response or token received.");
      }
    } catch (error: any) {
      console.error("Login failed:", error.message || error);
      setErrorMessage("Login failed. Please check your credentials.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Logowanie</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleLogin}>
          <Form.Group controlId="formEmail">
            <Form.Label>Adres email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Wprowadź email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="useremail"
            />
          </Form.Group>
          <Form.Group controlId="formPassword" className="mt-3">
            <Form.Label>Hasło</Form.Label>
            <Form.Control
              type="password"
              placeholder="Wprowadź hasło"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="userpassword"
            />
          </Form.Group>
          {errorMessage && (
            <div className="text-danger mt-3">{errorMessage}</div>
          )}
          <Button
            variant="primary"
            type="submit"
            className="mt-3"
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "Zaloguj się"}
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginModal;